import { render, staticRenderFns } from "./PmConfigDialog.vue?vue&type=template&id=bed78410&scoped=true"
import script from "./PmConfigDialog.vue?vue&type=script&lang=js"
export * from "./PmConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./PmConfigDialog.vue?vue&type=style&index=0&id=bed78410&prod&scoped=true&lang=css"
import style1 from "./PmConfigDialog.vue?vue&type=style&index=1&id=bed78410&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed78410",
  null
  
)

export default component.exports